// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"c02da485","89":"99770402","402":"341ee591","498":"1d387433","685":"4dc6c93e","937":"0769c082"}[chunkId] + ".chunk.js";
};